import pinZoomParkAndPOIMaxCount from '@alltrails/maps/utils/pinZoomParkAndPOIMaxCount';
import { useAppSelector } from '@/utils/redux';

const useMaxPOIPins = () => {
  const mapZoomBucket = useAppSelector(state => state.map.mapZoomBucket);
  return pinZoomParkAndPOIMaxCount(mapZoomBucket ?? 0).maxPOIs;
};

export default useMaxPOIPins;
